/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable consistent-return */
import Skeleton from '@mui/material/Skeleton';
import parse, { domToReact } from 'html-react-parser';
import dynamic from 'next/dynamic';
import React from 'react';
import LazyLoad from 'react-lazyload';
import getSlug from 'speakingurl';
import { imageProxy } from 'helpers/imageProxy';
import AmpImageGallery from '../components/Amp/AmpImageGallery';
import Link from '@mui/material/Link';
import {
  exitUrl,
  instagramPost,
  mentionUrl,
  postUrl,
  threespeakUrl,
} from './regex';
import { dimensionConverter } from 'helpers/dimensionConverter';
import Image from 'components/FutureImage';
import { findImageFromList } from 'helpers/findImageFromList';
import AffiliateBox from 'components/Post/AffiliateBox';
import JoinTfBox from 'components/Post/JoinTfBox';

const LinkTool = dynamic(() =>
  import('../components/Post/DynamicPostComponents/LinkTool'),
);
const ItineraryEmbed = dynamic(() =>
  import('../components/Post/DynamicPostComponents/ItineraryEmbed'),
);
const AmpItineraryEmbed = dynamic(() =>
  import('../components/Post/DynamicPostComponents/AmpItineraryEmbed'),
);
const PostBtn = dynamic(() =>
  import('../components/Post/DynamicPostComponents/PostBtn'),
);
const TableOfContents = dynamic(() =>
  import('../components/Post/DynamicPostComponents/TableOfContents'),
);
const IgEmbed = dynamic(
  () => import('../components/Post/DynamicPostComponents/IgEmbed'),
  {
    ssr: false,
  },
);
const MasonryImageGallery = dynamic(
  () => import('../components/Post/DynamicPostComponents/MasonryImageGallery'),
  {
    ssr: false,
  },
);
const ImageGallery = dynamic(
  () => import('../components/Post/DynamicPostComponents/ImageGallery'),
  {
    ssr: false,
  },
);

const parseHtmlToReact = (htmlBody, options) => {
  const { allImgDetails } = options;
  const isWebp = options.webpSupport;

  const embeds = {};
  const images = [];
  const totalParagraphs = (htmlBody.match(/<p>/g) || []).length;
  const parseLinksToBlank = options && options.parseLinksToBlank === true;

  const postHeight = options.windowHeight
    ? options.windowHeight - options.windowHeight * 0.14
    : 550;

  const parseImage = (attribs, noFigure, parentIsLink) => {
    const doNotConvert = attribs.src.substr(attribs.src.length - 4) === '.gif';
    const notConvertedSrc = imageProxy(
      attribs.src,
      undefined,
      undefined,
      'fit',
    );
    const attribHeight = undefined;
    const attribWidth = undefined;
    const imgHeight = attribHeight || '100%';
    const imgWidth = attribWidth || undefined;
    const fetchHeight =
      attribHeight && attribHeight > 0 && attribHeight < 700
        ? attribHeight
        : 700;
    let webpSrc = doNotConvert
      ? notConvertedSrc
      : imageProxy(attribs.src, undefined, fetchHeight, 'fit', 'webp', true);
    let regSrc = doNotConvert
      ? notConvertedSrc
      : imageProxy(attribs.src, undefined, fetchHeight, 'fit', undefined, true);
    if (options.cardWidth && options.cardWidth <= 500) {
      // on mobile, loading a smaller version is sufficient
      webpSrc = doNotConvert
        ? notConvertedSrc
        : imageProxy(
            attribs.src,
            options.cardWidth,
            undefined,
            'fit',
            'webp',
            true,
          );
      regSrc = doNotConvert
        ? notConvertedSrc
        : imageProxy(
            attribs.src,
            options.cardWidth,
            undefined,
            'fit',
            undefined,
            true,
          );
    }
    const lightboxImg = { src: isWebp ? webpSrc : regSrc };
    if (!options.hideimgcaptions && attribs.alt)
      lightboxImg.caption = attribs.alt;
    const useLightbox =
      options.toggleLightbox && (!attribHeight || attribHeight > 400);
    if (useLightbox) {
      images.push(lightboxImg);
    }
    if (options.amp) {
      const innerAmp = (
        <>
          {(attribHeight && attribWidth && attribHeight < attribWidth && (
            <amp-img
              alt={attribs.alt}
              layout="responsive"
              src={webpSrc}
              width={attribWidth}
              height={attribHeight}
            >
              <amp-img
                alt={attribs.alt}
                fallback=""
                layout="responsive"
                src={regSrc}
                width={attribWidth}
                height={attribHeight}
              />
            </amp-img>
          )) || (
            <div className="fixed-height-container">
              <amp-img
                alt={attribs.alt}
                src={webpSrc}
                class="contain"
                layout="fill"
              >
                <amp-img
                  alt={attribs.alt}
                  fallback=""
                  src={regSrc}
                  class="contain"
                  layout="fill"
                />
              </amp-img>
            </div>
          )}
        </>
      );
      if (noFigure) return innerAmp;
      return (
        <figure className="ampstart-image-with-caption m0 relative mb4">
          {innerAmp}
          {attribs.alt !== undefined &&
            // ignore alt texts with image name
            !attribs.alt.match(/(DSC_|\.gif|\.jpg|\.jpeg|\.png)/i) &&
            !options.hideimgcaptions && <figcaption>{attribs.alt}</figcaption>}
        </figure>
      );
    }
    let imgDetails = allImgDetails
      ? findImageFromList(attribs.src, allImgDetails)
      : { width: attribs.width, height: attribs.height, url: attribs.src };
    if (!imgDetails || !imgDetails.width || !imgDetails.height)
      imgDetails = {
        width: attribs.width,
        height: attribs.height,
        url: attribs.src,
      };
    let innerPic = (
      <picture>
        <source type="image/webp" srcSet={webpSrc} />
        <img
          alt={attribs.alt}
          src={regSrc}
          className="img-fluid mx-auto d-block"
          style={{
            maxHeight: `${postHeight}px`,
            width: imgHeight < imgWidth ? '100%' : 'auto',
          }}
          height={imgHeight}
          width={imgWidth}
        />
      </picture>
    );
    if (imgDetails && imgDetails.width && imgDetails.height) {
      const { width, height } = dimensionConverter(
        imgDetails.width,
        imgDetails.height,
        undefined,
        600,
      );
      const useLightbox =
        !parentIsLink &&
        imgDetails.width &&
        imgDetails.width > 600 &&
        imgDetails.height &&
        imgDetails.height > 300;
      const handleLightboxToggle = useLightbox
        ? () => options.toggleLightbox(attribs.src)
        : undefined;
      if (
        useLightbox &&
        attribs.alt &&
        allImgDetails &&
        allImgDetails.length > 0
      ) {
        allImgDetails.forEach((image, i) => {
          if (image.url === attribs.src) {
            allImgDetails[i]['alt'] = attribs.alt;
          }
        });
      }
      innerPic = (
        <Image
          priority={imgDetails.pos === 0}
          src={notConvertedSrc}
          alt={attribs.alt || ''}
          height={height}
          width={width}
          blurDataURL={imgDetails.blur}
          placeholder={imgDetails.blur ? 'blur' : undefined}
          onClick={handleLightboxToggle}
          onKeyPress={handleLightboxToggle}
          className={
            'tw-h-auto tw-max-w-full' +
            (useLightbox ? ' tw-cursor-zoom-in' : '') +
            (imgDetails &&
            imgDetails.width > 1200 &&
            imgDetails.width / imgDetails.height > 1.3
              ? ' tw-w-full'
              : '')
          }
        />
      );
    }
    if (noFigure) return innerPic;
    return (
      <figure className="tw-text-center">
        {innerPic}
        {attribs.alt !== undefined &&
          // ignore alt texts with image name
          !attribs.alt.match(/(DSC_|\.gif|\.jpg|\.png)/i) &&
          !options.hideimgcaptions && <figcaption>{attribs.alt}</figcaption>}
      </figure>
    );
  };

  const imgParseOptions = {
    replace: ({ name, attribs, children }) => {
      if (!attribs) return;
      // Replace exit urls with Link component
      if (
        name === 'a' &&
        attribs.href &&
        attribs.href[0] === '/' &&
        children.length > 0
      ) {
        const exitLink = attribs.href.match(exitUrl);
        if (exitLink) {
          if (options.isUgcLinks)
            return (
              <a
                rel="noopener noreferrer ugc"
                target="_blank"
                href={decodeURIComponent(exitLink[1])}
              >
                {domToReact(children, imgParseOptions)}
              </a>
            );
          if (options.setExternalLinkModal)
            return (
              <a
                onClick={() =>
                  options.setExternalLinkModal(decodeURIComponent(exitLink[1]))
                }
                className="cpointer"
              >
                {domToReact(children, parseOptions)}
              </a>
            );
          return (
            <Link href={`/exit?url=${exitLink[1]}`} legacyBehavior>
              <a>{domToReact(children, imgParseOptions)}</a>
            </Link>
          );
        }
      }
      if (
        name === 'img' &&
        attribs.src &&
        attribs.frameborder === undefined &&
        attribs.allowfullscreen === undefined
      ) {
        return parseImage(attribs, true);
      }
    },
  };

  let currentParagraph = 0;

  const parseOptions = {
    replace: ({ name, attribs, children, parent }) => {
      if (!attribs) return;

      if (options.showAffiliateBox && name && name === 'p') {
        currentParagraph += 1;
        if (currentParagraph > 10 && currentParagraph === totalParagraphs - 9) {
          return (
            <>
              <p>{domToReact(children)}</p>
              <JoinTfBox />
            </>
          );
        }
        // Check if this is the penultimate paragraph
        if (currentParagraph > 5 && currentParagraph === totalParagraphs - 4) {
          return (
            <>
              <p>{domToReact(children)}</p>
              <AffiliateBox countryCode={options.countryCode} />
            </>
          );
        }
      }

      if (
        (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4') &&
        children &&
        children.length > 0 &&
        children[0].data &&
        typeof children[0].data === 'string'
      ) {
        attribs.id = getSlug(children[0].data);
      }

      if (parseLinksToBlank && attribs.href) {
        // Open links in new tab
        attribs.target = '_blank';
        return;
      }

      if (name === 'figure') {
        const justFigure = (
          <figure className="tw-text-center">
            {domToReact(children, imgParseOptions)}
          </figure>
        );
        if (options.amp) return justFigure;
        return justFigure;
      }
      // Proxify image urls and add lazyload and conditional webp
      if (
        name === 'img' &&
        attribs.src &&
        attribs.frameborder === undefined &&
        attribs.allowfullscreen === undefined
      ) {
        const isParentLink = parent && parent.name === 'a';
        return parseImage(attribs, undefined, isParentLink);
      }

      // Replace exit urls with Link component
      if (
        name === 'a' &&
        attribs.href &&
        attribs.href[0] === '/' &&
        children.length > 0
      ) {
        const exitLink = attribs.href.match(exitUrl);
        if (exitLink) {
          if (exitLink.length > 1) {
            const threeSpeakMatch = exitLink[1].match(threespeakUrl);
            if (threeSpeakMatch && threeSpeakMatch.length === 3) {
              let childHasImage;
              domToReact(children, {
                replace: ({ name, attribs }) => {
                  if (!attribs) return;
                  if (name === 'img') {
                    childHasImage = true;
                  }
                },
              });
              if (childHasImage)
                return (
                  <div className="videoWrapper">
                    <LazyLoad
                      once
                      offset={700}
                      height={attribs.height}
                      placeholder={
                        <Skeleton
                          className="fullwidth"
                          variant="rectangular"
                          width="100%"
                          height={Number(attribs.height)}
                        />
                      }
                    >
                      <iframe
                        title="3Speak embedded player"
                        src={`https://3speak.tv/embed?v=${threeSpeakMatch[1]}/${threeSpeakMatch[2]}`}
                        width={attribs.width || '960'}
                        height={attribs.height || '540'}
                        frameborder="0"
                        allowFullScreen
                        className="fullWidthIframe"
                      />
                    </LazyLoad>
                  </div>
                );
            }
          }
          if (options.isUgcLinks)
            return (
              <a
                rel="noopener noreferrer ugc"
                target="_blank"
                href={decodeURIComponent(exitLink[1])}
              >
                {domToReact(children, imgParseOptions)}
              </a>
            );
          if (options.setExternalLinkModal)
            return (
              <a
                onClick={() =>
                  options.setExternalLinkModal(decodeURIComponent(exitLink[1]))
                }
                className="cpointer"
              >
                {domToReact(children, parseOptions)}
              </a>
            );
          return (
            <Link href={`/exit?url=${exitLink[1]}`} legacyBehavior>
              <a>{domToReact(children, parseOptions)}</a>
            </Link>
          );
        }
      }

      // Replace local mentions with Link component
      if (name === 'a' && attribs.href && children.length > 0) {
        const mention = attribs.href.match(mentionUrl);
        if (mention) {
          return (
            <Link href={`/@${mention[1]}`} legacyBehavior>
              <a>{domToReact(children, parseOptions)}</a>
            </Link>
          );
        }
      }
      if (name === 'div' && attribs.json) {
        let json = {};
        let title = '';
        let description = '';
        let image = '';
        let author = '';
        let permlink = '';
        let btnText = '';
        let btnLink = '';
        let type;
        let btnWhitelist = false;
        try {
          json = JSON.parse(attribs.json);
        } catch {
          return <></>;
        }
        if (json.type === 'button') {
          try {
            btnText = json.data.text;
            btnLink = json.data.link;
            btnWhitelist = json.data.isWhitelist;
          } catch {
            return <></>;
          }
          return (
            <PostBtn
              text={btnText}
              link={btnLink}
              isWhitelist={btnWhitelist}
              parseLinksToBlank={parseLinksToBlank}
              isUgcLinks={options.isUgcLinks}
              setExternalLinkModal={options.setExternalLinkModal}
            />
          );
        }
        if (json.type === 'linkTool') {
          try {
            title = json.data.meta.title;
            description = json.data.meta.description;
            image = json.data.meta.image;
            author = json.data.meta.author;
            permlink = json.data.meta.permlink;
            type = json.data.meta.type;
          } catch {
            return <></>;
          }
          if (type === 'itinerary') {
            if (options.amp)
              return <AmpItineraryEmbed author={author} permlink={permlink} />;
            return <ItineraryEmbed author={author} permlink={permlink} />;
          }
          return (
            <>
              <LinkTool
                isAmp={options.amp}
                author={author}
                permlink={permlink}
                title={title}
                description={description}
                image={image}
              />
            </>
          );
        }
        if (json.type === 'imageGallery') {
          let galleryImages;
          let style;
          try {
            galleryImages = json.data.images;
            style = json.data.style;
          } catch {
            return <></>;
          }
          if (options.amp) {
            embeds.carousel = true;
            embeds.selector = true;
            embeds.lightbox = true;
          }
          // Add captions for lightbox
          if (
            allImgDetails &&
            allImgDetails.length > 0 &&
            galleryImages &&
            galleryImages.length > 0
          ) {
            galleryImages.forEach(galleryImg => {
              allImgDetails.forEach((image, i) => {
                if (image.url === galleryImg.url) {
                  allImgDetails[i]['alt'] = galleryImg.caption;
                }
              });
            });
          }
          if (style === 'masonry') {
            return options.amp ? (
              <AmpImageGallery images={galleryImages} isWebp={isWebp} />
            ) : (
              <MasonryImageGallery
                galleryImages={galleryImages}
                allImgDetails={allImgDetails}
                isWebp={isWebp}
                toggleLightbox={options.toggleLightbox}
              />
            );
          }
          return options.amp ? (
            <AmpImageGallery images={galleryImages} isWebp={isWebp} />
          ) : (
            <ImageGallery
              images={galleryImages}
              allImgDetails={allImgDetails}
              isWebp={isWebp}
              toggleLightbox={options.toggleLightbox}
            />
          );
        }
        let headings = [];
        if (json.type === 'tableOfContents')
          try {
            headings = json.data.headings;
          } catch {
            return <></>;
          }
        return <TableOfContents headings={headings} />;
      }
      if (name === 'iframe' && attribs.src) {
        if (!options.amp) {
          const igmatch = /(?:http[s]?:\/\/)?(?:www.)?instagram\.com\/p\/(.*)\//i.exec(
            attribs.src,
          );
          if (igmatch) {
            return (
              <div className="container-fluid pt-2">
                <div className="row justify-content-center">
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-10 col-12 p-0">
                    <IgEmbed
                      url={`https://www.instagram.com/p/${igmatch[1]}`}
                    />
                  </div>
                </div>
              </div>
            );
          }
          const truvvlMatch = /^(https?:)?\/\/embed\.truvvl\.com\/@.*/i.exec(
            attribs.src,
          );
          if (attribs.frameborder) {
            attribs.frameBorder = attribs.frameborder;
            delete attribs.frameborder;
          }
          if (attribs.allowfullscreen) {
            attribs.allowFullScreen = attribs.allowfullscreen;
            delete attribs.allowfullscreen;
          }
          return (
            <LazyLoad
              once
              offset={700}
              height={truvvlMatch ? 700 : attribs.height}
              placeholder={
                <Skeleton
                  className="fullwidth"
                  variant="rectangular"
                  width="100%"
                  height={Number(attribs.height)}
                />
              }
            >
              {truvvlMatch ? (
                <iframe {...attribs} height="700" width="375" frameBorder="0" />
              ) : (
                <iframe {...attribs} className="fullWidthIframe" />
              )}
            </LazyLoad>
          );
        }
        const ytmatch = /https:\/\/www\.youtube\.com\/embed\/(.*)/.exec(
          attribs.src,
        );
        if (ytmatch) {
          embeds.youtube = true;
          return (
            <amp-youtube
              data-videoid={ytmatch[1]}
              layout="responsive"
              width={attribs.width}
              height={attribs.height}
            />
          );
        }
        const vmmatch = /https:\/\/player\.vimeo\.com\/video\/([0-9]*)/.exec(
          attribs.src,
        );
        if (vmmatch) {
          embeds.vimeo = true;
          return (
            <amp-vimeo
              data-videoid={vmmatch[1]}
              layout="responsive"
              width={attribs.width || '960'}
              height={attribs.height || '540'}
            />
          );
        }
        const igmatch = instagramPost.exec(attribs.src);
        if (igmatch) {
          embeds.instagram = true;
          return (
            <amp-instagram
              data-shortcode={igmatch[1]}
              width="400"
              height="400"
              layout="responsive"
            />
          );
        }
        embeds.iframe = true;
        return (
          <amp-iframe
            allowfullscreen={attribs.allowfullscreen}
            width={attribs.width || '800'}
            height={attribs.height || '400'}
            sandbox="allow-scripts allow-same-origin"
            layout="responsive"
            frameborder="0"
            src={attribs.src}
          />
        );
      }
    },
  };

  return { bodyText: parse(htmlBody, parseOptions), embeds, images };
};

export default parseHtmlToReact;
